import { action } from 'satcheljs';
export default action('folderPrefetchedAction', function (folderId) {
    return {
        folderId: folderId,
    };
});
//# sourceMappingURL=folderPrefetchedAction.js.map